import { render, staticRenderFns } from "./DialogPassword.vue?vue&type=template&id=6d1069bd"
import script from "./DialogPassword.vue?vue&type=script&lang=js"
export * from "./DialogPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports